<template>
  <a-drawer width="65%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <!--<a-form-model-item prop="shopId" >-->
        <!--<span slot="label" >-->
          <!--<a-tooltip>-->
            <!--{{$t('拼团活动商品.店铺id')}}<template slot="title">{{$t('拼团活动商品.店铺id')}}</template>-->
          <!--</a-tooltip>-->
        <!--</span>-->
        <!--<a-input v-model="form.shopId"  :placeholder="$t('通用.输入.请输入')+$t('拼团活动商品.店铺id')" />-->
      <!--</a-form-model-item>-->
      <!--<a-form-model-item prop="goodsId" >-->
        <!--<span slot="label" >-->
          <!--<a-tooltip>-->
            <!--{{$t('拼团活动商品.商品id')}}<template slot="title">{{$t('拼团活动商品.商品id')}}</template>-->
          <!--</a-tooltip>-->
        <!--</span>-->
        <!--<a-input v-model="form.goodsId"  :placeholder="$t('通用.输入.请输入')+$t('拼团活动商品.商品id')" />-->
      <!--</a-form-model-item>-->
      <a-form-model-item prop="shopIds" >
        <span slot="label" >
          <a-tooltip>
            选择门店<template slot="title">选择参与拼团活动的门店，用户通过该门店购买会扣减该门店的库存</template>
          </a-tooltip>
        </span>
        <a-select v-model="form.shopIds" mode="multiple" placeholder="请选择门店" allow-clear show-search :filter-option="filterOption">
          <a-select-option v-for="item in shopList" :key="item.id" :value="item.id">
            {{ item.shopName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="acName" >
        <span slot="label" >
          <a-tooltip>
            {{$t('拼团活动商品.活动名称')}}<template slot="title">{{$t('拼团活动商品.活动名称')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.acName" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('拼团活动商品.活动名称')" />
      </a-form-model-item>
      <a-form-model-item prop="groupValidTime" >
        <span slot="label" >
          <a-tooltip>
            {{$t('拼团有效期（小时）')}}<template slot="title">{{$t('拼团有效期（小时）')}}</template>
          </a-tooltip>
        </span>
        <a-input-number v-model="form.groupValidTime"  :placeholder="$t('通用.输入.请输入')+$t('拼团活动商品.拼团有效期')" />
      </a-form-model-item>
      <a-form-model-item prop="groupNumber" >
        <span slot="label" >
          <a-tooltip>
            {{$t('拼团活动商品.成团人数')}}<template slot="title">{{$t('拼团活动商品.成团人数')}}</template>
          </a-tooltip>
        </span>
        <a-input-number v-model="form.groupNumber"  :placeholder="$t('通用.输入.请输入')+$t('拼团活动商品.成团人数')" />
      </a-form-model-item>
      <!--<a-form-model-item prop="goodsName" >-->
        <!--<span slot="label" >-->
          <!--<a-tooltip>-->
            <!--{{$t('拼团活动商品.商品名称')}}<template slot="title">{{$t('拼团活动商品.商品名称')}}</template>-->
          <!--</a-tooltip>-->
        <!--</span>-->
        <!--<a-input v-model="form.goodsName" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('拼团活动商品.商品名称')" />-->
      <!--</a-form-model-item>-->
      <!--<a-form-model-item prop="acPrice" >-->
        <!--<span slot="label" >-->
          <!--<a-tooltip>-->
            <!--{{$t('拼团活动商品.拼团价格')}}<template slot="title">{{$t('拼团活动商品.拼团价格')}}</template>-->
          <!--</a-tooltip>-->
        <!--</span>-->
        <!--<a-input v-model="form.acPrice"  :placeholder="$t('通用.输入.请输入')+$t('拼团活动商品.拼团价格')" @change="limitMarketPrice()"/>-->
      <!--</a-form-model-item>-->
      <!--<a-form-model-item prop="goodsPrice" >-->
        <!--<span slot="label" >-->
          <!--<a-tooltip>-->
            <!--{{$t('拼团活动商品.原价')}}<template slot="title">{{$t('拼团活动商品.原价')}}</template>-->
          <!--</a-tooltip>-->
        <!--</span>-->
        <!--<a-input v-model="form.goodsPrice"  :placeholder="$t('通用.输入.请输入')+$t('拼团活动商品.原价')" />-->
      <!--</a-form-model-item>-->
      <!--<a-form-model-item prop="goodsPicture" >-->
        <!--<span slot="label" >-->
          <!--<a-tooltip>-->
            <!--{{$t('拼团活动商品.商品图片')}}<template slot="title">{{$t('拼团活动商品.商品图片')}}</template>-->
          <!--</a-tooltip>-->
        <!--</span>-->
        <!--<a-input v-model="form.goodsPicture" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('拼团活动商品.商品图片')" />-->
      <!--</a-form-model-item>-->
      <!--<a-form-model-item prop="checkStatus" >-->
        <!--<span slot="label" >-->
          <!--<a-tooltip>-->
            <!--{{$t('拼团活动商品.状态： 1：待审核   2：审核失败  3：审核成功,4:过期未审核  5：活动已结束')}}<template slot="title">{{$t('拼团活动商品.状态： 1：待审核   2：审核失败  3：审核成功,4:过期未审核  5：活动已结束')}}</template>-->
          <!--</a-tooltip>-->
        <!--</span>-->
      <!--</a-form-model-item>-->
      <!--<a-form-model-item prop="auditMessage" >-->
        <!--<span slot="label" >-->
          <!--<a-tooltip>-->
            <!--{{$t('拼团活动商品.拒绝原因')}}<template slot="title">{{$t('拼团活动商品.拒绝原因')}}</template>-->
          <!--</a-tooltip>-->
        <!--</span>-->
        <!--<a-input v-model="form.auditMessage" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('拼团活动商品.拒绝原因')" />-->
      <!--</a-form-model-item>-->
      <a-form-model-item prop="acStartTime" >
        <span slot="label" >
          <a-tooltip>
            {{$t('拼团活动商品.拼团开始时间')}}<template slot="title">{{$t('拼团活动商品.拼团开始时间')}}</template>
          </a-tooltip>
        </span>
        <!--<a-date-picker style="width: 100%" v-model="form.acStartTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>-->
        <a-date-picker style="width: 100%" v-model="form.acStartTime" valueFormat="YYYY-MM-DD HH:mm:ss" show-time allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="acEndTime" >
        <span slot="label" >
          <a-tooltip>
            {{$t('拼团活动商品.拼团结束时间')}}<template slot="title">{{$t('拼团活动商品.拼团结束时间')}}</template>
          </a-tooltip>
        </span>
        <!--<a-date-picker style="width: 100%" v-model="form.acEndTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>-->
        <a-date-picker style="width: 100%" v-model="form.acEndTime" valueFormat="YYYY-MM-DD HH:mm:ss" show-time allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="maxBuyBount" >
        <span slot="label" >
          <a-tooltip>
            {{$t('拼团活动商品.最大购买数量')}}<template slot="title">{{$t('拼团活动商品.最大购买数量')}}</template>
          </a-tooltip>
        </span>
        <a-input-number v-model="form.maxBuyBount"  :placeholder="$t('通用.输入.请输入')+$t('拼团活动商品.最大购买数量')" />
      </a-form-model-item>
      <a-form-model-item prop="virtualGroupEnable" >
        <span slot="label" >
          <a-tooltip>
            虚拟成团<template slot="title">开启后，拼团剩余时间≤30分钟且未满团时，系统自动完成拼团</template>
          </a-tooltip>
        </span>
        <a-switch v-model="form.virtualGroupEnable" true-value="1" false-value="0" />
        <span style="margin-left: 10px; color: #999;">开启后，拼团即将超时且未满团时自动完成</span>
      </a-form-model-item>
      <!--<a-form-model-item prop="completeTotal" >-->
        <!--<span slot="label" >-->
          <!--<a-tooltip>-->
            <!--{{$t('拼团活动商品.完成拼团数量')}}<template slot="title">{{$t('拼团活动商品.完成拼团数量')}}</template>-->
          <!--</a-tooltip>-->
        <!--</span>-->
        <!--<a-input v-model="form.completeTotal" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('拼团活动商品.完成拼团数量')" />-->
      <!--</a-form-model-item>-->
      <!--<a-form-model-item prop="remark" >-->
        <!--<span slot="label" >-->
          <!--<a-tooltip>-->
            <!--{{$t('拼团活动商品.备注')}}<template slot="title">{{$t('拼团活动商品.备注')}}</template>-->
          <!--</a-tooltip>-->
        <!--</span>-->
        <!--<a-input v-model="form.remark" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />-->
      <!--</a-form-model-item>-->






      <!--选择商品-->
      <a-form-model-item :label="$t('通用.文本.选择商品')" prop="goodsId">
        <a-button type="dashed" @click="openProdSelect" danger>
          <span style="color: dodgerblue"> {{$t('通用.文本.选择商品')}}</span>
        </a-button>
      </a-form-model-item>
      <!-- 数据展示 -->
      <a-row>
        <a-col :span="24">
          <a-table
            :loading="goodsLoading"
            rowKey="id"
            :size="tableSize"
            :columns="goodsColumns"
            :data-source="form.goodsList"
            :pagination="false"
            :bordered="tableBordered"
            style="margin-bottom: 20px; width: 80%;">
            <span slot="createTime" slot-scope="text, record">
              {{ parseTime(record.createTime) }}
            </span>
            <template slot="picture" slot-scope="text, record">
              <div>
                <img v-if="record.picture" :src="record.picture"  style="width:60px;height:62px;" @click="handleRecordPreview(record.picture)" alt="none"/>
              </div>
            </template>

            <span slot="categoryId" slot-scope="text, record">
                {{getCategoryNameById(record.categoryId)}}
            </span>
            <span slot="brandId" slot-scope="text, record">
                 {{getBrandNameById(record.brandId)}}
              </span>
            <span slot="status" slot-scope="text, record">
               <custom-dict-tag :options="customDict.GoodsStatusEnum" :value="record.status"/>
              </span>
          </a-table>
        </a-col>
      </a-row>

      <!-- SKU拼团价格设置 -->
      <a-row v-if="form.goodsId">
        <a-col :span="24">
          <div style="margin-bottom: 10px; font-weight: bold;">SKU拼团价格设置</div>
          <template v-if="form.skuList && form.skuList.length > 0">
            <a-alert message="请为每个SKU设置拼团价格,拼团价格必须大于0" type="info" style="margin-bottom: 10px;" show-icon />
            <a-table
              :loading="skuLoading"
              rowKey="id"
              :size="tableSize"
              :columns="skuColumns"
              :data-source="form.skuList"
              :pagination="false"
              :bordered="tableBordered"
              style="width: 80%"
            >
              <template slot="skuPicture" slot-scope="text, record">
                <div>
                  <img v-if="record.picture" :src="record.picture" style="width:40px;height:40px;" @click="handleRecordPreview(record.picture)" alt="none"/>
                </div>
              </template>
              <template slot="groupPrice" slot-scope="text, record">
                <a-input-number
                  v-model="record.groupPrice"
                  :min="0"
                  :precision="2"
                  placeholder="请输入拼团价格"
                  style="width: 100%"
                  @change="limitSkuGroupPrice(record)"
                />
              </template>
            </a-table>
          </template>
          <a-alert v-else message="请先选择商品" type="warning" />
        </a-col>
      </a-row>

      <!--选择商品-->










      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>

      <!--选择商品-->
      <radio-goods-select-form ref="RadioGoodsSelectForm" @goodsSelect="indexGoodsModalSelect"></radio-goods-select-form>
      <!--选择商品-->

    </a-form-model>
  </a-drawer>
</template>

<script>
  import { getGroupActivityProd, addGroupActivityProd, updateGroupActivityProd } from '@/api/groupActivityProd/groupActivityProd'
  import {mapGetters} from 'vuex'
  import CustomDictTag from "@/components/DictCustomTag";
  import {generateFilePath, uploadObject} from "@/api/tool/oss";
  //选择商品
  import RadioGoodsSelectForm from "@/views/groupActivityProd/groupActivityProd/modules/RadioSelectForm";
  import {listCategory} from "@/api/goods/category";
  import {allBrand} from "@/api/goods/brand";
  import {listByMerchantId, listShop} from "@/api/shop/shop";
  //选择商品
  export default {
    name: 'CreateForm',
    props: {
    },
    components: {
      CustomDictTag,
      //选择商品
      RadioGoodsSelectForm
      //选择商品
    },
    data () {
      return {
        labelCol: { span: 4 },
        wrapperCol: { span: 14 },
        submitLoading: false,
        formTitle: '',
        previewImageVisible: false,
        previewUrl: '',
        previewVideoVisible: false,
        loading: '',
        skuLoading: false,
        goodsLoading: false,
        //选择商品
        categoryList:[],
        shopList: [],
        goodsColumns: [
          {
            title: this.$t('商品.商品名称'),
            dataIndex: 'goodsName',
            width: 100,
          },
          {
            title: this.$t('商品.商品主图'),
            dataIndex: 'picture',
            width: 70,
            scopedSlots: {customRender: 'picture'},
          },

          // {
          //   title: this.$t('商品.市场价'),
          //   width: 80,
          //   dataIndex: 'marketPrice',
          // },
          {
            title: this.$t('商品.商品价'),
            width: 80,
            dataIndex: 'price',
          },
        ],
        // SKU列表
        skuColumns: [
          {
            title: 'SKU名称',
            dataIndex: 'skuName',
            width: 100,
          },
          // {
          //   title: '规格',
          //   dataIndex: 'specValueIds',
          //   width: 80,
          // },
          // {
          //   title: 'SKU图片',
          //   dataIndex: 'picture',
          //   width: 60,
          //   scopedSlots: {customRender: 'skuPicture'},
          // },
          {
            title: '原价',
            dataIndex: 'price',
            width: 70,
          },
          {
            title: '拼团价格',
            dataIndex: 'groupPrice',
            width: 100,
            scopedSlots: {customRender: 'groupPrice'},
          },
        ],
        //选择商品
        // 表单参数
        form: {
          //选择商品
          goodsList: [],
          skuList: [],
          //选择商品
          id: null,

          shopId: null,

          goodsId: null,

          acName: null,

          groupValidTime: null,

          groupNumber: null,

          goodsName: null,

          acPrice: null,

          goodsPrice: null,

          goodsPicture: null,

          checkStatus: '0',

          auditMessage: null,

          acStartTime: null,

          acEndTime: null,

          maxBuyBount: null,

          completeTotal: null,


          createTime: null,

          remark: null,

          virtualGroupEnable: 0, // 虚拟成团开关，默认关闭

        },
        // 1增加,2修改
        formType: 1,
        open: false,
        rules: {
          shopIds: [
            { required: true, message: '请选择门店', trigger: 'change', type: 'array' }
          ],
          // goodsId: [
          //   { required: true, message: this.$t('拼团活动商品.商品id')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
          // ],
          acName: [
            { required: true, message: this.$t('拼团活动商品.活动名称')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
          ],
          groupValidTime: [
            { required: true, message: this.$t('拼团活动商品.拼团有效期')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
          ],
          groupNumber: [
            { required: true, message: this.$t('拼团活动商品.成团人数')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
          ],
          goodsName: [
            { required: true, message: this.$t('拼团活动商品.商品名称')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
          ],
          checkStatus: [
            { required: true, message: this.$t('拼团活动商品.状态： 1：待审核   2：审核失败  3：审核成功,4:过期未审核  5：活动已结束')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
          ],
          acStartTime: [
            { required: true, message: this.$t('拼团活动商品.拼团开始时间')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
          ],
          acEndTime: [
            { required: true, message: this.$t('拼团活动商品.拼团结束时间')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
          ]
        }
      }
    },
    filters: {
    },
    created () {
      //选择商品
      this.getCateList();
      this.getBrandList();
      this.getShopList();
      //选择商品
    },
    computed: {
      ...mapGetters(['customDict', 'tableSize', 'tableBordered'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        //选择商品
        goodsList: [],
        skuList: [],
        //选择商品
        id: null,
        shopId: null,
        shopIds: [],
        goodsId: null,
        acName: null,
        groupValidTime: null,
        groupNumber: null,
        goodsName: null,
        acPrice: null,
        goodsPrice: null,
        goodsPicture: null,
        checkStatus: '0',
        auditMessage: null,
        acStartTime: null,
        acEndTime: null,
        maxBuyBount: null,
        completeTotal: null,
        createTime: null,
        remark: null,
        virtualGroupEnable: 0, // 虚拟成团开关，默认关闭
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getGroupActivityProd({"id":id}).then(response => {
        this.form = response.data
        // 加载SKU列表
        if (response.data.goodsId) {
          this.loadSkuList(response.data.goodsId)
        }
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    //选择商品
    indexGoodsModalSelect(records) {
      this.form.goodsId = records[0].id
      this.form.goodsList = records
      this.loadSkuList(records[0].id)
      console.log('商品选择了',this.form.goodsList)
    },
    // 加载SKU列表
    loadSkuList(goodsId) {
      console.log('开始加载SKU列表, goodsId:', goodsId)
      this.skuLoading = true

      // 先加载商品详情以获取规格信息
      import('@/api/goods/goods').then(({ querySkuByGoodsId, getGoods }) => {
        Promise.all([
          querySkuByGoodsId(goodsId),
          getGoods({ id: goodsId })
        ]).then(([skuResponse, goodsResponse]) => {
          console.log('获取SKU列表成功:', skuResponse.data)
          console.log('获取商品详情成功:', goodsResponse.data)

          const skuList = skuResponse.data || []
          const goodsDetail = goodsResponse.data || {}
          const specList = goodsDetail.specList || []

          // 创建规格值ID到规格名称的映射
          const specValueMap = {}
          specList.forEach(spec => {
            if (spec.specValueList) {
              spec.specValueList.forEach(specValue => {
                specValueMap[specValue.id] = {
                  specName: spec.specName,
                  specValueName: specValue.specValueName
                }
              })
            }
          })
          console.log('规格值映射:', specValueMap)

          this.form.skuList = skuList.map(sku => {
            // 解析specValueIds (格式可能是 "id1:id2:id3")
            let skuName = sku.skuName || ''
            if (sku.specValueIds) {
              const specValueIdArray = sku.specValueIds.split(':')
              const specNameArray = []
              specValueIdArray.forEach(id => {
                const specInfo = specValueMap[id]
                if (specInfo) {
                  specNameArray.push(`${specInfo.specName}:${specInfo.specValueName}`)
                }
              })
              if (specNameArray.length > 0) {
                skuName = specNameArray.join(' ')
              }
            }

            return {
              id: sku.id,
              skuId: sku.id,
              skuName: skuName,
              specValueIds: sku.specValueIds || '',
              picture: sku.picture || '',
              price: sku.price || 0,
              groupPrice: sku.groupPrice || 0
            }
          })
          console.log('SKU处理后数据:', this.form.skuList)
          this.skuLoading = false
        }).catch(error => {
          console.error('加载SKU列表失败:', error)
          this.skuLoading = false
        })
      })
    },
    openProdSelect() {
      // 查询平台商品 (shopId = 0)
      console.log('打开商品选择框,单选模式,查询平台商品')
      this.$refs.RadioGoodsSelectForm.openGoods(0, [this.form.goodsId]);
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          // 验证商品是否选择
          if (!this.form.goodsId) {
            this.$message.error('请选择商品')
            return false
          }

          // 验证SKU拼团价格
          if (!this.form.skuList || this.form.skuList.length === 0) {
            this.$message.error('该商品没有SKU,无法设置拼团价格')
            return false
          }

          for (let i = 0; i < this.form.skuList.length; i++) {
            const sku = this.form.skuList[i]
            if (!sku.groupPrice || sku.groupPrice <= 0) {
              this.$message.error(`SKU [${sku.skuName}] 的拼团价格不能为空且必须大于0`)
              return false
            }
          }

          // 构建提交数据
          const skuGroupPrices = this.form.skuList.map(sku => ({

            skuId: sku.skuId,
            groupPrice: sku.groupPrice
          }))
          console.log('准备提交的SKU拼团价格数据:', skuGroupPrices)

          // 计算最低拼团价
          let minGroupPrice = null
          this.form.skuList.forEach(sku => {
            if (sku.groupPrice > 0) {
              if (minGroupPrice === null || sku.groupPrice < minGroupPrice) {
                minGroupPrice = sku.groupPrice
              }
            }
          })

          const submitData = {
            ...this.form,
            skuGroupPrices: skuGroupPrices,
            acPrice: minGroupPrice // 设置最低拼团价
          }
          delete submitData.skuList
          delete submitData.goodsList

          console.log('最终提交的数据:', submitData)

          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateGroupActivityProd(submitData).then(response => {
              this.$message.success(
              message,
              3
            )
            this.open = false
              this.$emit('ok')
          }).finally(() => {
              this.submitLoading = false
          })
          } else {
            message = this.$t('通用.文本.添加成功')
            addGroupActivityProd(submitData).then(response => {
              this.$message.success(
              message,
              3
            )
            this.open = false
              this.$emit('ok')
          }).finally(() => {
              this.submitLoading = false
          })
          }
        } else {
          return false
        }
      })
    },
    limitSkuGroupPrice(sku) {
      let val = sku.groupPrice
      if (val == null || val == undefined || val === '') {
        sku.groupPrice = null
        return
      }
      if (val < 0) {
        sku.groupPrice = 0
      }
      if (val > 21474836) {
        sku.groupPrice = 21474836
      }
    },

    getBrandNameById(id) {
      if (!id) {
        return "";
      }
      let brandInfo = this.brandList.find(e => e.id === id);
      if (brandInfo) {
        return brandInfo.name
      } else {
        return "";
      }
    },
    getCategoryNameById(id) {
      if (!id) {
        return "";
      }
      let cateInfo = this.categoryList.find(e => e.id === id);
      if (cateInfo) {
        return cateInfo.categoryName
      } else {
        return "";
      }
    },
    getCateList() {
      listCategory().then(response => {
          this.categoryList = response.data;
          const cate = { id: "0", categoryName: this.$t('通用.文本.根节点'), children: [] }
          cate.children = this.handleTree(response.data, 'id','pid')
          this.cateOptions.push(cate)
        })
    },
    getBrandList() {
      allBrand().then(response => {
        this.brandList = response.data
    })
    },
    getShopList() {
      listByMerchantId({}).then(response => {
        this.shopList = response.data
      })
    },
    //下拉框搜索过滤
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    //选择商品



  }
  }
</script>
